export enum ActionTypes {
  FETCH_TABLE_DATA_REQUEST = 'experiments/FETCH_TABLE_DATA_REQUEST',
  FETCH_TABLE_DATA_RESPONSE = 'experiments/FETCH_TABLE_DATA_RESPONSE',
  FETCH_TABLE_DATA_ERROR = 'experiments/FETCH_TABLE_DATA_ERROR',
  FETCH_TABLE_FILTER_OPTION_REQUEST = 'experiments/FETCH_TABLE_FILTER_OPTION_REQUEST',
  FETCH_TABLE_FILTER_OPTION_RESPONSE = 'experiments/FETCH_TABLE_FILTER_OPTION_RESPONSE',
  FETCH_TABLE_FILTER_OPTION_ERROR = 'experiments/FETCH_TABLE_FILTER_OPTION_ERROR',
  TOGGLE_EXPERIMENT_SELECTION = 'experiments/TOGGLE_EXPERIMENT_SELECTION',
  ANALYTICS_PAGE_LOADED = 'experiments/ANALYTICS_PAGE_LOADED',
  ANALYTICS_PAGE_OVERVIEW_TAB_LOADED = 'experiments/ANALYTICS_PAGE_OVERVIEW_TAB_LOADED',
  ANALYTICS_PAGE_PERFORMANCE_TAB_LOADED = 'experiments/ANALYTICS_PAGE_PERFORMANCE_TAB_LOADED',
  ANALYTICS_BASE_PAGE_DATA_ERROR = 'experiments/ANALYTICS_BASE_PAGE_DATA_ERROR',
  ANALYTICS_OVERVIEW_TAB_DATA_ERROR = 'experiments/ANALYTICS_OVERVIEW_TAB_DATA_ERROR',
  ANALYTICS_PERFORMANCE_TAB_DATA_ERROR = 'experiments/ANALYTICS_PERFORMANCE_TAB_DATA_ERROR',
  ANALYTICS_OVERVIEW_TAB_DATA_LOADED = 'experiments/ANALYTICS_OVERVIEW_TAB_DATA_LOADED',
  ANALYTICS_PERFORMANCE_TAB_DATA_LOADED = 'experiments/ANALYTICS_PERFORMANCE_TAB_DATA_LOADED',
  ANALYTICS_RELOAD_OVERVIEW_TAB_DATA = 'experiments/ANALYTICS_RELOAD_OVERVIEW_TAB_DATA',
  ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA = 'experiments/ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA',
  SET_I18N_TRANSLATIONS = 'experiments/SET_I18N_TRANSLATIONS',
  SET_ANALYTICS_METRICS = 'experiments/SET_ANALYTICS_METRICS',
  SET_ANALYTICS_BASE_PAGE_DATA = 'experiments/SET_ANALYTICS_BASE_PAGE_DATA',
  SET_ANALYTICS_OVERVIEW_TAB_DATA = 'experiments/SET_ANALYTICS_OVERVIEW_TAB_DATA',
  SET_ANALYTICS_PERFORMANCE_TAB_DATA = 'experiments/SET_ANALYTICS_PERFORMANCE_TAB_DATA',
  UPDATE_EXPERIMENT_NAME = 'experiments/UPDATE_EXPERIMENT_NAME',
  OPEN_CHOOSE_CAMPAIGN = 'experiments/OPEN_CHOOSE_CAMPAIGN',
  CLOSE_CHOOSE_CAMPAIGN = 'experiments/CLOSE_CHOOSE_CAMPAIGN',
  FETCH_CHOOSE_CAMPAIGN_RESPONSE = 'experiments/FETCH_CHOOSE_CAMPAIGN_RESPONSE',
  SET_CHOOSE_CAMPAIGN_PAGINATION_INFO = 'experiments/SET_CHOOSE_CAMPAIGN_PAGINATION_INFO',
  REFETCH_CAMPAIGNS = 'experiments/REFETCH_CAMPAIGNS',
  SET_CAMPAIGN_SEARCH = 'experiments/SET_CAMPAIGN_SEARCH',
  SET_CHOOSE_CAMPAIGN_SORT_BY = 'experiments/SET_CHOOSE_CAMPAIGN_SORT_BY',
  SET_CHOOSE_CAMPAIGN_SORT_DIRECTION = 'experiments/SET_CHOOSE_CAMPAIGN_SORT_DIRECTION',
}
